import { ClerkProvider } from "@clerk/react";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import { launcherUrl, studioUrl } from "@/lib/auth-helpers";

import App from "./app";
import "./index.css";

const publishableKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY as
  | string
  | undefined;

if (!publishableKey) {
  throw new Error("VITE_CLERK_PUBLISHABLE_KEY is required");
}

const root = document.getElementById("root");
if (!root) {
  throw new Error("Missing #root");
}

createRoot(root).render(
  <StrictMode>
    <ClerkProvider
      afterSignOutUrl="/login"
      allowedRedirectOrigins={[studioUrl(), launcherUrl()]}
      publishableKey={publishableKey}
      signInUrl="/login"
      signUpUrl="/signup"
      taskUrls={{
        "choose-organization": "/session-tasks/choose-organization",
        "reset-password": "/session-tasks/reset-password",
      }}
      waitlistUrl="/signup"
    >
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ClerkProvider>
  </StrictMode>
);
